var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg047Label(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8301 2.45C15.6461 2.17061 15.3346 2.00173 15.0001 2H3.00007C2.647 2.00006 2.32013 2.1863 2.14007 2.49C1.96144 2.7994 1.96144 3.1806 2.14007 3.49L6.86007 12L2.13007 20.51C1.95144 20.8194 1.95144 21.2006 2.13007 21.51C2.31194 21.8168 2.64344 22.0035 3.00007 22H15.0001C15.3346 21.9983 15.6461 21.8294 15.8301 21.55L21.8301 12.55C22.0498 12.2163 22.0498 11.7837 21.8301 11.45L15.8301 2.45ZM14.4601 20H4.70007L8.87007 12.49C9.0487 12.1806 9.0487 11.7994 8.87007 11.49L4.70007 4H14.4601L19.8001 12L14.4601 20Z",
    fill: "#8199A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg047Label);
export default __webpack_public_path__ + "static/media/047-label.bfd96602eb536293a2f644c269dd9622.svg";
export { ForwardRef as ReactComponent };